module.exports = __webpack_public_path__ + "img/main_sub_card_health.adb7b228.png";